import {Component, Injector, OnInit} from '@angular/core';
import {BaseNewComponents} from '../../base-new-components';

@Component({
  selector: 'app-tips',
  templateUrl: './tips.component.html',
  styleUrls: ['./tips.component.sass']
})
export class TipsComponent extends BaseNewComponents implements OnInit {

  tipsText = [
    {id: 1, label: 'Escolha o número de diárias no plano que mais agrada o seu estilo de viajante.'},
    {id: 2, label: 'Excelente notícia, você não precisa usar todas as diárias de uma vez.'},
    {id: 3, label: 'Quando quiser viajar, acesse a nossa community e consulte os hotéis disponíveis.'},
    {
      id: 4,
      label: 'Importante! As diárias são moedas de troca. Caso escolha um hotel que esteja categorizado no plano diferente' +
          ' do que você assinou, as diárias podem variar.'
    },
    {id: 5, label: 'Pronto! Agora é só desfrutar de uma hospedagem incrível.'},
  ];

  tipsImage = [
    {id: 1, image: 'src/assets/img/view/new_home_background.jpg'},
    {id: 2, image: 'src/assets/img/view/new_home_background.jpg'},
    {id: 3, image: 'src/assets/img/view/new_home_background.jpg'}
  ];
  constructor(protected injector: Injector) {
    super(injector);
  }

  ngOnInit() {
  }

}
